// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__2lh3_","HeroImage":"Hero_HeroImage__vUAio","HeroBox":"Hero_HeroBox__ngXYr","HeroInfo":"Hero_HeroInfo__1YqMg","Small":"Hero_Small__z5d3i"};